// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6373) return "static/chunks/6373-e27713985c89d804.js";
	if (chunkId === 8357) return "static/chunks/8357-35c8312467facc99.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1965":"882589d4bcae489d","2966":"ca314c0ba0af4f7d","4346":"54c428f9e6a58713","5705":"6f3fbbac0179466d","8288":"e18b996014e88b21","9422":"c5bb9b963b60fc1d"}[chunkId] + ".js";
};